import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders } from '../../../../Containers/Config/index.js';
import { GET_BENEFIT_GROUPS_LIST, GET_BENEFIT_GROUPS_LIST_SUCCESS, GET_BENEFIT_GROUPS_LIST_ERROR } from './../../actionType.js';
import apiCall from '../../apiCall';
import { Constant } from '../../../../Containers/Helpers/constant.js';

function* getBenefitGroupsList({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${baseUrl}/admin/benefitGroups`,
      method: 'GET',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
      },
      params: {
        ...payload?.urlParam,
        pageSize: Constant?.TABLE_PAGE_SIZE,
      },
    });

    if (response.status === 200) {
      yield put({
        type: GET_BENEFIT_GROUPS_LIST_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_BENEFIT_GROUPS_LIST_ERROR,
        payload: response.response.data,
      });
    }
  } catch (error) {
    yield put({ type: GET_BENEFIT_GROUPS_LIST_ERROR, payload: error });
  }
}

export function* watchGetBenefitGroupList() {
  yield takeEvery(GET_BENEFIT_GROUPS_LIST, getBenefitGroupsList);
}

function* getBenefitGroupsListSaga() {
  yield all([fork(watchGetBenefitGroupList)]);
}

export default getBenefitGroupsListSaga;
